export default "__VITE_ASSET__Bp4ivwbx__"